module.exports = __webpack_public_path__ + "static/leaf3-01-d7b27ea4d470cbb3844b0be1d95a9b21.png";